import { useRequest } from 'ahooks'
import { Form, Modal } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { JQLEditContent } from '@/components/jql/jql-edit-content.component'
import { ResourceType } from '@/schemas'

import { Devlop } from '../../devlop.schema'
import { JiraColumnProps } from './devlop-jql-table-config.component'

interface DevlopJQLEditProps {
  columns: JiraColumnProps[]
  selfId: string
  jql: string | null
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  onSuccess: (jql: string) => void
  devlop: Devlop
}

export const DevlopJQLEdit: React.FC<DevlopJQLEditProps> = ({
  columns,
  selfId,
  jql,
  visible,
  setVisible,
  onSuccess,
  devlop,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const { run, loading } = useRequest(
    (jql) => ({
      url: `/api/devlop/patch/${selfId}`,
      method: 'patch',
      data: {
        jql,
      },
    }),
    {
      manual: true,
      onSuccess: (_, [jql]) => {
        onSuccess(jql)
        setVisible(false)
      },
    }
  )

  const onOk = () => {
    form.submit()
  }

  return (
    <Modal
      title={t('configure jql')}
      width='80vw'
      okText={t('save')}
      visible={visible}
      onOk={onOk}
      onCancel={() => setVisible(false)}
      okButtonProps={{ loading }}
    >
      <JQLEditContent
        columns={columns}
        form={form}
        jql={jql}
        onSubmit={run}
        entity={{ name: devlop.name, type: ResourceType.DEVLOP }}
      />
    </Modal>
  )
}
